module.exports = __webpack_public_path__ + "static/yir-demo-04-77998c1b0960e90205448450cd0138b5.mp3";